import TheGrid from '@/views/sales/sellout/grid'

export default {
  path: '/sales/sellout',
  redirect: '/sales/sellout/index',
  name: 'sellout',
  meta: {
    auth: {
      redirect: {
        name: 'sellout.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Sellout'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'sellout.index',
    component: TheGrid,
    meta: {
      auth: true,
      label: 'Vendas'
    }
  }]
}
